<template>
  <div>
    <v-file-input
      v-if="updatable"
      :label="`Upload ${label} CSV file ${mandatory ? '*' : ''}`"
      accept=".csv"
      outlined
      dense
      @change="handleFileUpload"
    />
    <div v-else>
      <h3>{{ label }}</h3>
    </div>
    <v-alert v-if="errorMessages.length > 0" color="error" dense outlined>
      <ul>
        <li v-for="message in errorMessages" :key="message">{{ message }}</li>
      </ul>
    </v-alert>
    <v-data-table
      v-if="parsedData.length > 0"
      :headers="headers"
      :items="parsedData"
      :hide-default-footer="true"
      disable-pagination
    >
      <template #[`item.recurring`]="{ item }">
        <v-switch
          v-model="item.recurring"
          class="switcher"
          :readonly="true"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script setup>
import Papa from 'papaparse';
import { computed, defineProps, defineEmits, ref, watch } from 'vue';

const emit = defineEmits(['input']);
const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  field: {
    type: Object,
    default: () => null
  },
  idType: {
    type: String,
    default: null
  },
  status: {
    type: String,
    default: null
  },
  updatable: {
    type: Boolean,
    default: false
  }
});

const label = computed(() => props.field.label);
const headers = computed(() => props.field.headers);
const idType = computed(() => props.field.idType);
const updatable = computed(() => !props.status || props.field.updatable);
const mandatory = computed(() => props.field.mandatory);
const parsedData = ref(props.value && props.value.length ? props.value : []);
const errorMessages = ref([]);

const handleFileUpload = file => {
  errorMessages.value = [];
  if (!file) {
    parsedData.value = [];
    return;
  }
  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: results => {
      parsedData.value = results.data.map(item => {
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const header = headers.value.find(h => h.value === key);
            if (header && header.type) {
              switch (header.type.toLowerCase()) {
                case 'float':
                  item[key] = parseFloat(item[key]);
                  break;
                case 'int':
                  item[key] = parseInt(item[key]);
                  break;
                case 'boolean':
                  item[key] = item[key].toLowerCase() === 'true';
                  break;
                default:
                  break;
              }
            }
          }
        }
        return item;
      });
    },
    error: error => {
      console.error('Error parsing CSV:', error);
    }
  });
};

watch(parsedData, () => {
  if (
    idType.value
    && parsedData.value.some(item => !item.uuid.startsWith(idType.value))
  ) {
    errorMessages.value.push(
      'Certains éléments ne correspondent pas au type de cet upload'
    );
  }
  emit('input', parsedData.value);
});
</script>
